import React from 'react';
import '../../styles/PagesStyles/Blogs.css'; // Import the CSS file for styling

const Blogs = () => {
  return (
      <div className="Blogs-container">
      <h1>Welcome to Combat Solutions</h1>
      <p>This is the Blogs page of our application.</p>
      {/* Add more content as needed */}
    </div>
  );
};

export default Blogs;